export type SortOrder = 'ASC' | 'DESC';

export enum SortOrderEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}
